import HomeAbstrait from "./home-abstrait"
import DoorCircle from "./door-circle"
import HomeCityLeft from "./home-city-left/"
import HomeCityRight from "./home-city-right/"
import MobileHandle from "./mobile-handle/"

export default {
  DoorCircle,
  HomeAbstrait,
  HomeCityLeft,
  HomeCityRight,
  MobileHandle
}